import Actions from '../../odata/actions';

const actions = new Actions('checklistTemplate', 'checklistTemplates');

export default actions;
